//Import CONFIG
import {
  NO_OF_ITEMS,
  Y_DISTANCE,
  X_DISTANCE,
  TOP_DISTANCE,
  ALLOWED_NUMBERS,
} from "../../config/Game";

//Import STORE
import { connect } from "react-redux";
import { store } from "../../../_core/core.Store";
import { action_setSelectedNumber } from "../../../_core/store/actions/actions.Game";

//Import CORE
import { useEffect, useState } from "react";

const DrawItem = (_props: any) => {
  const [classes, setClasses] = useState<string[]>([]);

  const getNumberPosition = (number: number) => {
    const top = TOP_DISTANCE + Math.floor(number / NO_OF_ITEMS) * Y_DISTANCE;
    const left = Math.floor(number % NO_OF_ITEMS) * X_DISTANCE + 5;

    return {
      top: top + "%",
      left: left + "%",
    };
  };

  const selectNumber = (_number: number) => {
    let _selectedNumbers = Object.values(
      _props.GAMEPLAY.selectedNumbers
    ).filter((item: any) => {
      return item.isSelected === true;
    });
    let _sameKey = Object.keys(_props.GAMEPLAY.selectedNumbers).find(
      (_el: any) =>
        _el === _number &&
        _props.GAMEPLAY.selectedNumbers[_el].isSelected === true
    );
    let _maxAllowed = Math.max(...ALLOWED_NUMBERS);

    if (
      _props.GAMEPLAY.currentTicket ||
      _props.GAMEPLAY.drawStart ||
      (!_sameKey && _selectedNumbers.length >= _maxAllowed)
    )
      return false;

    action_setSelectedNumber(_number)(store.dispatch);
  };

  const getNumberClass = (_number: number) => {
    let classes = ["game-ball-blank"];
    const lState = store.getState();

    let _selectedNumbers = lState.game.GAMEPLAY.selectedNumbers;

    if (
      _selectedNumbers[_number] &&
      (_selectedNumbers[_number].isSelected ||
        _selectedNumbers[_number].isConfirmed)
    ) {
      classes.push("game-ball-buyed");
    }

    setClasses(classes);
  };

  useEffect(() => {
    getNumberClass(_props.index + 1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getNumberClass(_props.index + 1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_props.GAMEPLAY.currentTicket]);

  useEffect(() => {
    getNumberClass(_props.index + 1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_props.GAMEPLAY.selectedNumbers]);

  return (
    <span
      className="game-ball-wrapper is-blank"
      style={getNumberPosition(_props.index)}
      data-number={_props.index + 1}
      onClick={() => selectNumber(_props.index + 1)}
    >
      <span className="game-ball">
        <span className={classes.join(" ")}>
          <span> {_props.index + 1}</span>
        </span>
      </span>
    </span>
  );
};

const mapStateToProps = (state: any) => {
  return {
    GAMEPLAY: state.game.GAMEPLAY,
  };
};

export default connect(mapStateToProps, {})(DrawItem);
